import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../../../../components/common/BriaButton/BriaButton";
import textShadow from "../../../../../../../assets/svgs/Text Shadow.svg";
import shapeShadow from "../../../../../../../assets/svgs/shapeShadow.svg";
import { useActiveObject } from "../../../../../../../hooks/useActiveObject";
import FabricShadow from "../../../../Toolbox/TextToolBar/FabricShadow/FabricShadow";
import styles from "./FabricElementsShadow.module.scss";
export type IProps = {
	showTextShadowIcon?: boolean;
};
const ShapesShadow = ({ showTextShadowIcon = false }: IProps) => {
	const activeObject = useActiveObject() as any;
	const [shadowAnchorEl, setShadowAnchorEl] = useState<HTMLButtonElement>();
	const { t } = useTranslation("translation", { keyPrefix: "editor.tabs" });

	const handleOpenShadowDialog = (event: React.MouseEvent<HTMLButtonElement>) => {
		setShadowAnchorEl(event.currentTarget);
	};
	const handleShadowAnchorElClose = () => {
		setShadowAnchorEl(undefined);
	};

	return (
		<Box className={styles.shapeShadowButtonsContainer}>
			<Box>
				<BriaButton
					buttonType="textMedium"
					onClick={handleOpenShadowDialog}
					className={clsx({
						[styles.shapeShadowButtonWrapper]: true,
						[styles.shapeShadowSelected]: !!activeObject?.shadow,
						[styles.textShadow]: showTextShadowIcon,
					})}
				>
					<img src={!showTextShadowIcon ? shapeShadow : textShadow} />
					<Typography className={styles.buttonLabel}>{t("shadow")}</Typography>
				</BriaButton>
				<FabricShadow
					open={!!shadowAnchorEl}
					handleClose={handleShadowAnchorElClose}
					anchorEl={shadowAnchorEl}
				/>
			</Box>
		</Box>
	);
};

const ObservedComponent = observer(ShapesShadow);
export default ObservedComponent;
